import { render } from "./MsgReplyDialog.vue?vue&type=template&id=3924c17c&scoped=true"
import script from "./MsgReplyDialog.vue?vue&type=script&lang=js"
export * from "./MsgReplyDialog.vue?vue&type=script&lang=js"

import "./MsgReplyDialog.vue?vue&type=style&index=0&id=3924c17c&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3924c17c"]])

export default __exports__